import React, { useState, useEffect } from 'react';
import {
  Rocket,
  Sparkles,
  Zap,
  Clock,
  CheckCircle,
  Star,
  TrendingUp,
  Bell,
  Mail,
  ArrowRight,
  Code,
  Cpu,
  Database,
  Globe,
  Lock,
  Shield,
  Target,
  Activity,
  BarChart3,
  Calendar,
  MessageSquare,
  Users,
  Settings,
} from 'lucide-react';
import { useTheme } from '../theme/ThemeContext';

const ComingSoonPage = ({ featureName = 'This Feature', featureIcon: FeatureIcon = Rocket }) => {
  const { theme } = useTheme();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 15,
    hours: 8,
    minutes: 42,
    seconds: 30
  });

  // Countdown timer effect
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        let { days, hours, minutes, seconds } = prev;
        
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 23;
          days--;
        }
        if (days < 0) {
          days = 0;
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        
        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setEmail('');
        setSubscribed(false);
      }, 5000);
    }
  };




  return (
    <div className="space-y-8">
      {/* Hero Section */}
      <div className="relative overflow-hidden rounded-3xl p-8 sm:p-12 lg:p-16 shadow-2xl">
        {/* Animated Background */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            background: `linear-gradient(135deg, ${theme.primary[600]} 0%, ${theme.secondary[600]} 100%)`
          }}
        >
          <div className="absolute top-0 left-0 w-full h-full">
            <div className="absolute top-10 left-10 w-32 h-32 rounded-full blur-3xl animate-pulse"
              style={{ backgroundColor: theme.primary[400] }}
            ></div>
            <div className="absolute bottom-10 right-10 w-40 h-40 rounded-full blur-3xl animate-pulse"
              style={{ backgroundColor: theme.secondary[400] }}
            ></div>
            <div className="absolute top-1/2 left-1/2 w-36 h-36 rounded-full blur-3xl animate-pulse"
              style={{ backgroundColor: theme.primary[500] }}
            ></div>
          </div>
        </div>

        {/* Main Background Gradient */}
        <div 
          className="absolute inset-0"
          style={{
            background: `linear-gradient(135deg, ${theme.primary[50]} 0%, ${theme.secondary[50]} 100%)`
          }}
        ></div>

        {/* Content */}
        <div className="relative text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center mb-6">
            <div 
              className="relative w-24 h-24 rounded-3xl flex items-center justify-center shadow-2xl animate-bounce"
              style={{
                background: `linear-gradient(135deg, ${theme.primary[600]} 0%, ${theme.secondary[600]} 100%)`
              }}
            >
              <FeatureIcon className="w-12 h-12 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center bg-yellow-400 shadow-lg animate-pulse">
                <Sparkles className="w-5 h-5 text-yellow-800" />
              </div>
            </div>
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm shadow-lg mb-6">
            <Clock className="w-4 h-4" style={{ color: theme.primary[600] }} />
            <span className="text-sm font-semibold" style={{ color: theme.primary[700] }}>
              Coming Soon
            </span>
          </div>

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-800 mb-4">
            {featureName} is
            <span 
              className="block mt-2"
              style={{
                background: `linear-gradient(135deg, ${theme.primary[600]} 0%, ${theme.secondary[600]} 100%)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Under Development
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto mb-8">
            We're working hard to bring you amazing new features. Get notified when this feature launches!
          </p>

       

        
        </div>
      </div>

      {/* Development Timeline */}
    

      {/* Upcoming Features Grid */}
    

      {/* CTA Section */}
     

      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-bounce {
          animation: bounce 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default ComingSoonPage;